import ImageCard from '@/components/@general/ImageCard/index.vue';

export default {
  name: 'SeriesCard',
  components: { ImageCard },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {
    dynamicRoute() {
      let { _isHit, parent, slug } = this.data;
      let name = _isHit ? 'collection' : 'brand';
      let params = parent && parent.slug ? { seria: slug, brandSeria: parent.slug } : { seria: slug };
      return { name, params };
    }
  },
  methods: {}
};
